import { fetchWithTokenRefresh } from "@/core/utils/http/fetch-with-token-refresh";

/** Limite do backend (`BrunaOpenedRequest.screen`): `[A-Za-z0-9_\-./]`, até 64 caracteres. */
const MAX_SCREEN_LENGTH = 64;

/**
 * Normaliza o pathname para o identificador de tela aceito pelo backend:
 * "/action-center/" → "action-center", "/" → "home".
 */
export function screenFromPathname(pathname: string): string {
  const screen = pathname
    .split(/[?#]/)[0]
    .replace(/[^A-Za-z0-9_\-./]/g, "")
    .replace(/^\/+|\/+$/g, "")
    .slice(0, MAX_SCREEN_LENGTH);
  return screen || "home";
}

/**
 * Registra o evento `bruna_aberta` (POST /api/agent/opened) com o usuário e a tela de origem.
 * O backend rejeita `user_id` vazio: quem chama garante o id (ver `useTrackBrunaOpened`).
 * Telemetria nunca deve quebrar a UI: erros são engolidos.
 */
export async function trackBrunaOpened(
  userId: number | string,
  screen: string,
): Promise<void> {
  try {
    const baseUrl =
      import.meta.env.VITE_AGENT_BASE_URL ||
      import.meta.env.VITE_API_GATEWAY_URL;
    if (!baseUrl) {
      console.error(
        "[bruna-opened-service] VITE_AGENT_BASE_URL / VITE_API_GATEWAY_URL ausentes",
      );
      return;
    }
    await fetchWithTokenRefresh(`${baseUrl}/api/agent/opened`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ user_id: String(userId), screen }),
    });
  } catch {
    // best-effort
  }
}
